import type { ComponentChildren, ComponentProps } from 'preact';
import { SwitchLabelValueLayout } from './SwitchLabelValueLayout';
import type { LayoutColumnSpan } from '#utils/UNSAFE_styles/Layout';
import { Switch } from './Switch';

type SwitchProps = ComponentProps<typeof Switch>;
type LabelProps = {
  label?: ComponentChildren;
  labelEdge?: SwitchProps['labelEdge'];
  labelStartWidth?: SwitchProps['labelStartWidth'];
};

type Props = LabelProps & {
  /**
   * Specifies how many columns to span in a FormLayout with direction === 'row'
   */
  columnSpan?: LayoutColumnSpan;

  inlineUserAssistance?: ComponentChildren;

  mainContent?: ComponentChildren;
};

export const SwitchField = ({
  columnSpan,
  inlineUserAssistance,
  label,
  labelEdge,
  labelStartWidth,
  mainContent
}: Props) => {
  // Use SwitchLabelValueLayout for labelEdge 'start', 'top', 'inside'
  if (labelEdge && labelEdge !== 'none') {
    return (
      <SwitchLabelValueLayout
        columnSpan={columnSpan}
        label={label}
        labelEdge={labelEdge}
        labelStartWidth={labelStartWidth}>
        {mainContent}
        {inlineUserAssistance}
      </SwitchLabelValueLayout>
    );
  }

  // Otherwise, for 'none', render children/assistance inline
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {mainContent}
      {inlineUserAssistance}
    </div>
  );
};
